import { action, makeObservable, observable } from 'mobx';
import { State, closed, open } from './Types';

class ShowExcessCompetencyStore {
  @observable
  state: State = closed();

  constructor() {
    makeObservable(this);
  }

  @action
  close = () => {
    this.state = closed();
  };

  @action
  open = () => {
    this.state = open();
  };
}

export default ShowExcessCompetencyStore;
